import ApiError from "lib/ApiError";
import {
    useGetSupplierInfoBySecuredId,
    useGetAuthenticateSupplierInfo,
    useGetSupplierInfoByCapacityLeadId,
    useGetSupplierInfo
} from "../../services/supplierInfoService";
import { RouteNames } from "layout/utils/SupplierContainer/routes";
import { IListOfBooking } from "layout/services/dtos";
import { useParams } from "react-router-dom";

interface UseSupplierDataReturn {
    supplierName: string;
    selectedSupplierId: string;
    error?: ApiError;
    bookingList: IListOfBooking[] | undefined;
    farmerName: string | undefined;
    farmerImage: string | undefined;
}

export const useSupplierData = (
    secureId: string,
    screenName: string,
    isAuthenticated: boolean
): UseSupplierDataReturn => {
    const { supplierId } = useParams() as { supplierId: string };

    const { data: unauthSupplierInfo, error: unauthError } =
        useGetSupplierInfoBySecuredId(secureId, {
            enabled:
                screenName.match(RouteNames.WAITING_LIST_DETAILS) != null &&
                !isAuthenticated &&
                secureId != undefined
        });

    const { data: authSupplierInfo, error: authError } =
        useGetAuthenticateSupplierInfo({
            enabled: isAuthenticated
        });

    const { data: supplierInfoByCapacityLeadId, error: capacityLeadError } =
        useGetSupplierInfoByCapacityLeadId(secureId, {
            enabled:
                screenName.match(RouteNames.CAPACITY_LEAD_DETAILS) != null &&
                !isAuthenticated &&
                secureId != undefined
        });

    const selectedSupplierId =
        authSupplierInfo?.supplierId ||
        unauthSupplierInfo?.supplierId ||
        supplierInfoByCapacityLeadId?.supplierId ||
        supplierId ||
        "";

    const { data: supplierBookingInfo, error: bookingError } =
        useGetSupplierInfo(selectedSupplierId, {
            enabled: selectedSupplierId != "" && selectedSupplierId != undefined
        });

    const supplierName =
        authSupplierInfo?.supplierName ||
        unauthSupplierInfo?.supplierName ||
        supplierInfoByCapacityLeadId?.supplierName ||
        supplierBookingInfo?.supplierName ||
        "";

    const bookingList: IListOfBooking[] | undefined =
        supplierBookingInfo?.listOfBookings;

    const farmerName: string | undefined = supplierBookingInfo?.farmerName;
    const farmerImage: string | undefined = supplierBookingInfo?.farmerImage;

    // Capture any API errors
    const error = (unauthError || authError || capacityLeadError) as ApiError;
    return {
        supplierName,
        selectedSupplierId,
        error,
        bookingList,
        farmerName,
        farmerImage
    };
};
